
/**
 * @class TASPositivePayCreateCheckTemplateFormUI
 * @classdesc Class definition for controlling the ui of the page.
 * @property {STRING} _id - The id of the positive pay check template form ui.
 * @property {TASPositivePayCreateCheckTemplateForm} _form - The form ui.
 * @property {BOOLEAN} _showFilePreview - The show file preview ui.
 * @property {OBJECT} _textQualifierDD - The text qualifier dropdown ui.
 * @property {ARRAY} _customItemTypeCodes - The custom item type codes ui.
 * @property {OBJECT} _mapColumnSelect1 - The map column select 1 ui.
 * @property {OBJECT} _mapColumnSelect2 - The map column select 2 ui.
 * @property {OBJECT} _mapColumnSelect3 - The map column select 3 ui.
 * @property {OBJECT} _mapColumnSelect4 - The map column select 4 ui.
 * @property {OBJECT} _mapColumnSelect5 - The map column select 5 ui.
 * @property {OBJECT} _mapColumnSelect6 - The map column select 6 ui.
 * @property {OBJECT} _mapColumnSelect7 - The map column select 7 ui.
 * @property {OBJECT} _mapColumnSelect8 - The map column select 8 ui.
 */
export default class TASPositivePayCreateCheckTemplateFormUI {
    constructor(record) {
        this.id = record.id;
        this.form = record.form;
        this.showFilePreview = record.showFilePreview;
        this.textQualifierDD = record.textQualifierDD;
        this.customItemTypeCodes = record.customItemTypeCodes
        this.mapColumnSelect1 = record.mapColumnSelect1;
        this.mapColumnSelect2 = record.mapColumnSelect2;
        this.mapColumnSelect3 = record.mapColumnSelect3;
        this.mapColumnSelect4 = record.mapColumnSelect4;
        this.mapColumnSelect5 = record.mapColumnSelect5;
        this.mapColumnSelect6 = record.mapColumnSelect6;
        this.mapColumnSelect7 = record.mapColumnSelect7;
        this.mapColumnSelect8 = record.mapColumnSelect8;
    }

    /**
     * @name id
     * @instance
     * @property set {STRING} - sets the id
     * @memberof TASPositivePayCreateCheckTemplateForm
     */
    set id(value) { this._id = value; }

    set form(value) { this._form = value; }
    set showFilePreview(value) { this._showFilePreview = value; }
    set textQualifierDD(value) { this._textQualifierDD = value; }
    set customItemTypeCodes(value) { this._customItemTypeCodes = value; }
    set mapColumnSelect1(value) { this._mapColumnSelect1 = value; }
    set mapColumnSelect2(value) { this._mapColumnSelect2 = value; }
    set mapColumnSelect3(value) { this._mapColumnSelect3 = value; }
    set mapColumnSelect4(value) { this._mapColumnSelect4 = value; }
    set mapColumnSelect5(value) { this._mapColumnSelect5 = value; }
    set mapColumnSelect6(value) { this._mapColumnSelect6 = value; }
    set mapColumnSelect7(value) { this._mapColumnSelect7 = value; }
    set mapColumnSelect8(value) { this._mapColumnSelect8 = value; }

    /**
     * @name id
     * @instance
     * @property get {STRING} - returns the id
     * @memberof TASPositivePayCreateCheckTemplateForm
     */
    get id() { return this._id; }

    get form() { return this._form; }
    get showFilePreview() { return this._showFilePreview; }
    get textQualifierDD() { return this._textQualifierDD; }
    get customItemTypeCodes() { return this._customItemTypeCodes; }
    get mapColumnSelect1() { return this._mapColumnSelect1; }
    get mapColumnSelect2() { return this._mapColumnSelect2; }
    get mapColumnSelect3() { return this._mapColumnSelect3; }
    get mapColumnSelect4() { return this._mapColumnSelect4; }
    get mapColumnSelect5() { return this._mapColumnSelect5; }
    get mapColumnSelect6() { return this._mapColumnSelect6; }
    get mapColumnSelect7() { return this._mapColumnSelect7; }
    get mapColumnSelect8() { return this._mapColumnSelect8; }

    /**
     * @name record
     * @instance
     * @property get {OBJECT} - returns the set values
     * @memberof TASPositivePayCreateCheckTemplateForm
     */
    get record() {
        return {
            id: this.id,
            form: this.form,
            showFilePreview: this.showFilePreview,
            textQualifierDD: this.textQualifierDD,
            customItemTypeCodes: this.customItemTypeCodes,
            mapColumnSelect1: this.mapColumnSelect1,
            mapColumnSelect2: this.mapColumnSelect2,
            mapColumnSelect3: this.mapColumnSelect3,
            mapColumnSelect4: this.mapColumnSelect4,
            mapColumnSelect5: this.mapColumnSelect5,
            mapColumnSelect6: this.mapColumnSelect6,
            mapColumnSelect7: this.mapColumnSelect7,
            mapColumnSelect8: this.mapColumnSelect8
        };
    }

    static defaultValues = {
        id: "0",
        form: undefined,
        showFilePreview: { isActive: false },
        textQualifierDD: { isActive: false },
        customItemTypeCodes: [],
        mapColumnSelect1: { isActive: false },
        mapColumnSelect2: { isActive: false },
        mapColumnSelect3: { isActive: false },
        mapColumnSelect4: { isActive: false },
        mapColumnSelect5: { isActive: false },
        mapColumnSelect6: { isActive: false },
        mapColumnSelect7: { isActive: false },
        mapColumnSelect8: { isActive: false }
    }

    reset() {
        return TASPositivePayCreateCheckTemplateFormUI.init(this.defaultValues);
    }
    
    static init(record) {
        const vals = { 
            ...this.defaultValues,
            ...record ?? {} 
        }
        return new TASPositivePayCreateCheckTemplateFormUI(vals);
    }
}